import CnFormPrototype from './cn-form/prototype';
import CnPagePrototype from './cn-page/prototype';
import CnFilterPrototype from './cn-filter/prototype';
import CnTablePrototype from './cn-table/prototype';
import CnFormDialogPrototype from './cn-form-dialog/prototype';
import CnStepPrototype from './cn-step/prototype';
import CnNavBarPrototype from './cn-nav-bar/prototype';
import CnDetailInfoPrototype from './cn-detail-info/prototype';
import CnTabPrototype from './cn-tab/prototype';
import CnMessagePrototype from './cn-message/prototype';
import CnCardPrototype from './cn-card/prototype';
import CnListPrototype from './cn-list/prototype';
import CnResultPrototype from './cn-result/prototype';
import packageJson from '../../package.json';
import CnEntryPointsPrototype from './cn-entry-points/prototype';
import { getCommonOpenUtil } from '../common/util';
import './prototype.scss';
if (!window.cnLowCodeUtils) {
    window.cnLowCodeUtils = {
        ...getCommonOpenUtil(),
    };
}
// 通过arr控制输出的顺序
const bundle = [
    CnFormPrototype,
    CnPagePrototype,
    CnFilterPrototype,
    CnTablePrototype,
    CnFormDialogPrototype,
    CnStepPrototype,
    CnNavBarPrototype,
    CnDetailInfoPrototype,
    CnTabPrototype,
    CnMessagePrototype,
    CnCardPrototype,
    CnListPrototype,
    CnResultPrototype,
    CnEntryPointsPrototype
];
console.log(`%cCN_UI_M_LOWCODE %c${packageJson?.version}`, 'color:#000;font-weight:bold;', 'color:green;font-weight:bold;');
export default bundle;
